import { ApiSliceParams } from "../interfaces";

export const makeClientStorage = ({ connection }: ApiSliceParams) => {
    const get = async (key: string): Promise<unknown> => {
        const con = connection.value;
        const storage = await con.clientStorage();

        const value = await storage.kvStore.get(key);

        return value;
    };

    const set = async (key: string, value: unknown): Promise<void> => {
        const con = connection.value;
        const storage = await con.clientStorage();

        await storage.kvStore.set(key, value);
    };

    return { get, set };
};
